import React from 'react';
import { Provider } from "react-redux";
import ModalDinamico from "../modalDinamico.cmpt";
import {eliminaDatosFiscales, getRegimenes, saveDatosFiscales, updateDatosFiscales, validaRfc} from "./datosfiscales.act";
import { goTo } from '../tools';
import moment from 'moment';
import $ from "../../src/jquery/jquery.min";
import Select from 'react-select';
import warningIcon from '../img/error_outline_24px.png';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const validacion = "VALIDACIÓN";
const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { isDisabled }) => {
      return {
        ...styles,
        color: "rgb(31, 63, 121)",
        fontWeight:"bold",
        backgroundColor:"transparent",
        textTransform:"uppercase",
        cursor: isDisabled ? "not-allowed" : "default",
        "&:hover": {
            borderColor: "red",
            backgroundColor:"#fff8e2",
            color: "#fd5422",

          }
      };
    }
};

export default class RegimenFiscal extends React.Component {
    state = {
        errorRazonSocial: false,
        errorRFC: false,
        errorCalle: false,
        errorCodigoPostal: false,
        errorColonia: false,
        errorEntidadFederativa: false,
        errorLocalidad: false,
        errorMunicipio: false,
        errorNoExterior: false,
        errorNoInterior: false,
        errorMsjRazonSocial: "",
        errorMsjRFC: "",
        errorMsjCalle: "",
        errorMsjNoExterior: "",
        errorMsjNoInterior: "",
        errorMsjColonia: "",
        errorMsjLocalidad: "",
        errorMsjMunicipio: "",
        errorMsjEntidadFederativa: "",
        disabled: false,
        validated:true,
        document:null,
        cveCliente:0,
        showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
        datosFiscales:{
            nombreCompleto:"",
            nombre:"",
            primerApellido:"",
            segundoApellido:"",
            rfc:"",
            cp:"",
            calle:"",
            nombreVialidad:"",
            numExt:"",
            tipoVialidad:"",
            numInt:"",
            colonia:"",
            municipio:"",
            entidadFederativa:"",
            localidad:"",
            regimen:{}
        },
        switchModal:true,
        regimenes:[],
        allRegimenes:[],
        fileId:"",
        modalDin:{
            fnBtnDer:()=>{},
            fnBtnIzq:()=>{},
            txtBtnDer:"",
            txtBtnIzq:"",
            titulo:"",
            mensaje:"",
            imgHeader:"",
            hasClose:false,
        },
        closeFn:()=>{},
        showModal:false,
        rfcURL:"https://www.sat.gob.mx/aplicacion/31274/consulta-tu-clave-de-rfc-mediante-curp",
        razonURL:"https://www.sat.gob.mx/consultas/44083/consulta-tu-informacion-fiscal",
        regimenURL:"https://www.sat.gob.mx/consultas/44083/consulta-tu-informacion-fiscal",
    };

    componentDidMount(){
        getRegimenes().then((res)=>{
            var formatRegimenes = [];
            res.result.map(regimen=>{
                if(regimen.persona === "F"){
                    formatRegimenes.push(regimen);
                }
            });
            this.setState({allRegimenes:formatRegimenes})
            this.setState({regimenes:formatRegimenes});
        }).catch((err)=>{
            console.log("ERROR AL TRAER REGIMENES: "+err);
        });
        var redux_state = this.props.redux.getState();
        this.setState({
            clienteUnico : redux_state.global.clienteUnico,
            tid: redux_state.global.tid,
        })
    }

    removeFile = () =>{
        this.props.redux.dispatch({ "type": "LOADER", "show": true });
        const cveUnica = this.state.clienteUnico;
        const tid = this.state.tid;
        const fileId = this.state.fileId;
        eliminaDatosFiscales(cveUnica, fileId, tid).then((res)=>{
            this.props.redux.dispatch({ "type": "LOADER", "show": false });
            this.setState({
                idFileBucket:"", 
                datosFiscales:{nombre:"",rfc:"",cp:"",calle:"",localidad:"",numExt:"",numInt:"",colonia:"",municipio:"",entidadFederativa:"",
                regimen:{}}
            });
            this.setState({regimenes:this.state.allRegimenes});
            
            archivo.style.display = "block";
            existeArchivo.style.display = "none"
            constanciaInput.value = "";
            this.resetValidationErrors();
            console.log("Eliminados Datos Fiscales!");
            this.close();
        }).catch((err)=>{
            this.props.redux.dispatch({ "type": "LOADER", "show": false });
            this.setState({showModal:true});
            archivo.style.display = "none";
            existeArchivo.style.display = "flex";
            const modalData = {
                fnBtnDer:()=>{},
                fnBtnIzq:()=>{window.location.reload()},
                txtBtnDer:"",
                txtBtnIzq:"Recarga la página",
                titulo:"Error al eliminar tu documento",
                mensaje:"Tenemos problemas para eliminar el archivo que ha subido, favor de recargar la página.",
                imgHeader:require("../img/warning-new-style.svg"),
                hasClose:false,
            };
            this.setState({modalDin: modalData})
            console.log("Error eliminandoPDF:"+ err);
        });
    }

    resetValue = () =>{
            var existeArchivo = document.getElementById("existeArchivo");
            var archivo = document.getElementById("archivo");
            var constanciaInput = document.getElementById("constanciaInput");
            this.setState({regimenes:this.state.allRegimenes});
            archivo.style.display = "block";
            existeArchivo.style.display = "none"
            constanciaInput.value = "";
    }

    handleChange = (event) => {
        var archivo = document.getElementById("archivo");
        var existeArchivo = document.getElementById("existeArchivo");
        const cveUnica = this.state.clienteUnico;
        const tid = this.state.tid;
        if (event.target.value !== "") {
            if(event.target.files.length > 0){
                this.props.redux.dispatch({ "type": "LOADER", "show": true });
                archivo.style.display = "none";
                existeArchivo.style.display = "flex";
                
                const document = event.target.files[0];
                this.setState({document});
                saveDatosFiscales(cveUnica,document, tid).then((res)=>{
                    this.props.redux.dispatch({ "type": "LOADER", "show": false });
                    this.setState({showModal:false});
                    this.setState({validated:true});
                    const data = res.data;
                    this.resetValidationErrors();
                    data.nombre = `${data.nombre} ${data.primerApellido} ${data.segundoApellido}`.trim();
                    data.nombreCompleto = `${data.nombre} ${data.primerApellido} ${data.segundoApellido}`.trim();
                    data.regimen=data.regimenes[0];
                    data.calle = data.nombreVialidad;
                    
                    const regimenesNew = data.regimenes.map(reg=>{
                        reg.clave = reg.clave ? reg.clave : reg.code;
                        reg.descripcion = reg.title;
                        reg.persona =reg.tipoPersona.charAt(0);
                        return reg;
                    })

                    data.nombre = data.nombre.substr(0,254);
                    data.rfc = data.rfc.substr(0,13);
                    data.cp = data.cp.substr(0,5);
                    data.calle = data.calle.substr(0,60);
                    data.numExt = data.numExt.substr(0,10);
                    data.numInt = data.numInt.substr(0,10);
                    data.colonia = data.colonia.substr(0,50);
                    data.municipio = data.municipio.substr(0,60);
                    data.entidadFederativa = data.entidadFederativa.substr(0,60);
                    
                    this.setState({
                        datosFiscales: data,
                        fileId:data.idFileBucket,
                        regimenes:regimenesNew,
                    });
                }).catch((err)=>{
                    this.setState({showModal:true});
                    this.props.redux.dispatch({ "type": "LOADER", "show": false });
                    const modalData = {
                        fnBtnDer:()=>{
                            window.open("https://www.sat.gob.mx/aplicacion/login/53027/genera-tu-constancia-de-situacion-fiscal", '_blank').focus();
                        },
                        fnBtnIzq:this.resetValue(),
                        txtBtnDer:"Ir al portal SAT",
                        txtBtnIzq:"Intentarlo de nuevo",
                        titulo:"Ingresa tus datos manualmente o verifica tu archivo.",
                        mensaje:
                        "Confirma que el archivo esté en formato PDF y sea el mismo archivo que descargaste directamente del portal del SAT.",
                        imgHeader:require("../img/warning-new-style.svg"),
                        hasClose:true,
                    };
                    this.setState({modalDin: modalData});
                    console.log("Error guardandoPDF:"+ err);
                });
            }else{
                this.setState({showModal:true});
                this.props.redux.dispatch({ "type": "LOADER", "show": false });
                const modalData = {
                    fnBtnDer:()=>{window.open("https://www.sat.gob.mx/aplicacion/login/53027/genera-tu-constancia-de-situacion-fiscal", '_blank').focus();},
                    fnBtnIzq: this.resetValue(),
                    txtBtnDer:"Ir al portal SAT",
                    txtBtnIzq:"Intentarlo de nuevo",
                    titulo:"Ingresa tus datos manualmente o verifica tu archivo.",
                    mensaje:
                    "Confirma que el archivo esté en formato PDF y sea el "+
                    "mismo archivo que descargaste directamente del portal del SAT.",
                    imgHeader:require("../img/warning-new-style.svg"),
                    hasClose:true,
                };
                this.setState({modalDin: modalData});
            }
        }
    }

    changeInput = (event) =>{
        const id = event.target.id;
        const datosFiscales = this.state.datosFiscales;
        let stateValue = datosFiscales[id];
        let valor = event.target.value;
        if(id === "rfc"){
            valor = valor.replaceAll(' ', '').trim();
        }
        stateValue = valor.replaceAll('  ', ' ').toUpperCase();
        datosFiscales[id] = stateValue;
        this.setState({datosFiscales});
    }

    verify = (event) => {
        const id = event.target.id;
        const datosFiscales = this.state.datosFiscales;
        let stateValue = datosFiscales[id];
        const valor = event.target.value.trim().toUpperCase();
        let isRequired = true;
        let errorBool = "";
        let errorMsj = "";
        let nombreCampo = "";
        let tipoValidacion = 0;
        
        if (id === "nombre") {
            errorBool = "errorRazonSocial";
            errorMsj = "errorMsjRazonSocial";
            nombreCampo = "nombre o razón social";
            tipoValidacion = 4;
        }
        if (id === "rfc") {
            errorBool = "errorRFC";
            errorMsj = "errorMsjRFC";
            nombreCampo = "rfc";
            tipoValidacion = 3;
        }
        if (id === "cp") {
            errorBool = "errorCodigoPostal";
            errorMsj = "errorMsjCodigoPostal";
            nombreCampo = "código postal";
            tipoValidacion = 2;
        } 
        if (id === "calle") {
            errorBool = "errorCalle";
            errorMsj = "errorMsjCalle";
            nombreCampo = "calle";
        } 
        if (id === "numExt") {
            errorBool = "errorNoExterior";
            errorMsj = "errorMsjNoExterior";
            nombreCampo = "número exterior";
            tipoValidacion = 1;
        } 
        if (id === "numInt") {
            errorBool = "errorNoInterior";
            errorMsj = "errorMsjNoInterior";
            nombreCampo = "número interior";
            tipoValidacion = 1;
            isRequired = false;
        }
        if (id === "colonia") {
            errorBool = "errorColonia";
            errorMsj = "errorMsjColonia";
            nombreCampo = "colonia";
        } 
        if (id === "municipio") {
            errorBool = "errorMunicipio";
            errorMsj = "errorMsjMunicipio";
            nombreCampo = "municipio";
        } 
        if (id === "entidadFederativa") {
            errorBool = "errorEntidadFederativa";
            errorMsj = "errorMsjEntidadFederativa";
            nombreCampo = "entidad federativa";
        }
        
        const mensajeErrorVacio = "El dato "+nombreCampo+" es requerido.";
        const mensajeErrorInvalido = "El dato "+nombreCampo+" es inválido." ;
        if (isRequired && valor.length === 0) {
            this.setState({ [errorBool]: true }); 
            this.setState({ [errorMsj]: mensajeErrorVacio});
            setTimeout(() => { 
                this.setState({ [errorMsj]:""}); 
                this.setState({ [errorBool]: false }); 
            }, 2000);
            this.setState({validated:false});
        }else{
            this.validateValue(errorBool,errorMsj,mensajeErrorInvalido,mensajeErrorVacio,tipoValidacion,valor,isRequired);
        }
        stateValue = valor.trim().toUpperCase();
        datosFiscales[id] = stateValue
        this.setState({datosFiscales});
    }

    validateValue = (leyendaError, leyendaMensajeError, mensajeError, mensajeErrorVacio ,tipoValidar, valor, isRequired) =>{
        var regexprsoloNumeros = /^([0-9 ])*$/;
        var regexprsoloSignos = /^[_!"`'¿#-.%&,°¬´¨:;<>=@{}~\$\(\)\*\¡\+\/\\\?\[\]\^\|]+$/;
        var regExprRFC = /^[A-Z,ñ,Ñ,&]{4}(\d{2}(?:0[0-9]|1[0-2])(?:0[0-9]|[12]\d|3[01]))[0-9A-Z]{3}$/i;
        let validated = true;
        this.setState({ [leyendaError] : false }); 
        this.setState({ [leyendaMensajeError] : "" });
        let validaciones;
        switch (tipoValidar){
            case 0:
                validaciones = false;
                break;
            case 1:
                validaciones= regexprsoloSignos.test(valor);
                break;
            case 2:
                validaciones = valor.length < 5 || !regexprsoloNumeros.test(valor) || regexprsoloSignos.test(valor);
                break;
            case 3:
                validaciones = !regExprRFC.test(valor);
                break;
            default:
                validaciones = false;
                break;
            }
        if (tipoValidar === 3){
            valor = valor.replaceAll(' ', ''); 
            var fechaRFC = valor.substr(4,6);
            var anioActualCorto = moment().format("YY");
            var anioRFCCorto = fechaRFC.substr(0,2);
            var fechaRFCFormatted = moment(fechaRFC, "YYMMDD",true);
            if(anioRFCCorto > anioActualCorto){
                fechaRFCFormatted = moment("19"+fechaRFC, "YYYYMMDD",true);
            }
            var now = fechaRFCFormatted.isValid();
            if(!now || fechaRFCFormatted > moment()){
                this.setState({ [leyendaError]: true }); 
                this.setState({ [leyendaMensajeError]: mensajeError });
                validated = false;
            }
        }
        if (validaciones) {
            this.setState({ [leyendaError]: true }); 
            this.setState({ [leyendaMensajeError]: mensajeError });
            validated = false;
        }
        this.setState({validated});
        return valor;
    }

    resetValidationErrors(){
        this.setState({ errorMsjRazonSocial: "" });
        this.setState({ errorMsjRFC: "" });
        this.setState({ errorMsjCodigoPostal: "" });
        this.setState({ errorMsjNoExterior: "" });
        this.setState({ errorMsjNoInterior: "" });
        this.setState({ errorMsjCalle: "" });
        this.setState({ errorMsjColonia: "" });
        this.setState({ errorMsjMunicipio: "" });
        this.setState({ errorMsjLocalidad: "" });
        this.setState({ errorMsjEntidadFederativa: "" });
        this.setState({errorRazonSocial:false});
        this.setState({errorRFC:false});
        this.setState({errorCodigoPostal:false});
        this.setState({errorCalle:false});
        this.setState({errorNoExterior:false});
        this.setState({errorNoInterior:false});
        this.setState({errorColonia:false});
        this.setState({errorMunicipio:false});
        this.setState({errorEntidadFederativa:false});
        this.setState({errorLocalidad:false});
    }

    close = () => {
        var archivo = document.getElementById("archivo");
        var existeArchivo = document.getElementById("existeArchivo");
        archivo.style.display = "block";
        existeArchivo.style.display = "none"
    }

    handleGameClik() {
        var isDisabled = !this.state.disabled;
        if(isDisabled){
            const modalData = {
                fnBtnDer:()=>{window.location.href="tel:5552279000";},
                fnBtnIzq:()=>{},
                txtBtnDer:"Llamar a Línea GNP",
                txtBtnIzq:"Aceptar",
                titulo:"Recuerda",
                mensaje:<div className='modalSwitch'><p>La información que ingreses debe ser idéntica a la de tu Constancia de Situación Fiscal y está se verá
                reflejada en las pólizas que aparezcas como contratante.<br/><br/>
                En caso de que los datos que ingreses sean diferentes a los del SAT, los documentos fiscales de
                tu póliza serán emitidos con datos genéricos y no servirán para su deducibilidad.<br/><br/>Cualquier duda o asistencia por favor comunícate a línea GNP.</p></div>,
                imgHeader:"",
                hasClose:true,
            };
            this.setState({modalDin: modalData});
            this.setState({showModal:true});
        }
        this.setState({ 
            disabled: isDisabled,
            switchModal: false,
        });
        const {datosFiscales} = this.state; 
        const {nombre,rfc,cp,calle,numExt,numInt,colonia,municipio,entidadFederativa} = datosFiscales;
        const isDataEmpty = nombre ==="" && cp ==="" && calle ==="" && numExt ==="" && numInt === "" && colonia ==="" && rfc ==="" &&
            municipio ==="" && entidadFederativa ==="" && constanciaInput.value === "" && typeof regimen === undefined;
        let DISABLE = true;
        if(!isDisabled && !isDataEmpty){
            const modalData = {
                fnBtnDer:()=>{
                    this.setState({idFileBucket:"", 
                    datosFiscales:{
                        nombre:"",
                        rfc:"",
                        cp:"",
                        calle:"",
                        localidad:"",
                        numExt:"",
                        numInt:"",
                        colonia:"",
                        municipio:"",
                        entidadFederativa:"",
                        regimen:{}}
                    });
                    this.setState({regimenes:this.state.allRegimenes});
                    archivo.style.display = "block";
                    existeArchivo.style.display = "none";
                    constanciaInput.value = "";
                    this.resetValidationErrors();
                    DISABLE = !DISABLE;
                    this.setState({disabled:DISABLE});
                },
                fnBtnIzq:()=>{this.setState({disabled:DISABLE})},
                txtBtnDer:"Desactivar opción",
                txtBtnIzq:"Cancelar",
                titulo:"¿Desactivar esta opción?",
                mensaje:"Al desactivarla se borrará la información que ingresaste y tendrás que llenar el formulario nuevamente.",
                imgHeader:require("../img/warning-new-style.svg"),
                hasClose:true,
            };
            this.setState({modalDin: modalData});
            this.setState({
                closeFn:()=>{
                    this.setState({disabled:DISABLE}); 
                    this.setState({closeFn:()=>{}})
                }
            });
            this.setState({showModal:true});
            
        }

    }

    changeRegimen = (e) => {
            const  value  = e.value;
            const {regimenes, datosFiscales} = this.state;
            regimenes.forEach(reg=>{
                if(reg.clave === value){
                    datosFiscales.regimen = reg;
                    this.setState({datosFiscales});
                }
                return;
            });
    }

    validarRFC =() => {
        this.props.redux.dispatch({ "type": "LOADER", "show": true });
        const datosFiscales = this.state.datosFiscales;
        const uid = this.state.clienteUnico;
        const tid = this.state.tid;

        validaRfc(uid, datosFiscales.rfc, tid).then((res)=>{
                this.props.redux.dispatch({ "type": "LOADER", "show": false });

                if(res === null || res === undefined) {
                    this.openModal(datosFiscales.rfc);
                } else if(res.error && res.error === true) {
                    this.muestraTooltip(true, 'error', validacion, "Ocurrio un error, intente más tarde.");
                } else {
                    this.saveDatos();
                }
                
        }).catch((err)=>{
                this.props.redux.dispatch({ "type": "LOADER", "show": false });
                console.log("EL RFC ES DIFERENTE:", err);
                this.muestraTooltip(true, 'error', validacion, "Ocurrio un error, intente más tarde.");
        });
    }

    openModal = (rfc) => {
        const modalData = {
            fnBtnDer:()=>{this.setState({showModal:false});},
            fnBtnIzq:()=>{this.saveDatos();},
            txtBtnDer:"No, modificar",
            txtBtnIzq:"Si, actualizar",
            titulo:"Verifica tu RFC",
            mensaje:<div className='modalSwitch'>
                <p>El RFC ingresado <b>{rfc}</b> no coincide con el RFC que teníamos registrado.</p>
                <p>¿Aún así deseas actualizarlo para la emisión de tus comprobantes fiscales?</p>
            </div>,
            imgHeader: warningIcon,
            hasClose:true,
        };
        this.setState({modalDin: modalData});
        this.setState({showModal:true});
    }

    saveDatos(){
        const datosFiscales = this.state.datosFiscales;
        const cveCliente = this.state.clienteUnico;
        const tid = this.state.tid;
        this.props.redux.dispatch({ "type": "LOADER", "show": true });
        datosFiscales.cveRegimenFiscal = datosFiscales.regimen.clave;
        datosFiscales.calle = datosFiscales.calle !== "" ? datosFiscales.calle.toUpperCase() : datosFiscales.nombreVialidad;

        updateDatosFiscales(cveCliente,datosFiscales, tid).then((res)=>{
            this.props.redux.dispatch({ "type": "LOADER", "show": false });
            this.props.redux.dispatch({ type: 'DATOS_FISCALES', saved:true});
            console.log("SE HAN GUARDADO LOS DATOS CORRECTAMENTE");
            goTo("mi-perfil");
        }).catch((err)=>{
            this.props.redux.dispatch({ "type": "LOADER", "show": false });
            $("body").append("<button id='erBtnMod' data-toggle='modal' data-target='#modal-err'></button>");
            $("#erBtnMod").click().remove();
            console.log("NO SE GUARDARON DATOS:"+ err);
        });
    } 
    
    deleteFile = () =>{
        this.close(); 
        this.removeFile()
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

    cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

    render() {
        const options = this.state.regimenes.map(function (city) {
            return { value: city.clave, label: city.descripcion };
        })
        const {showModal, modalDin, disabled, validated, datosFiscales, closeFn, rfcURL, razonURL, regimenURL } = this.state;
        const {nombre,rfc,cp,calle,numExt,numInt,colonia,municipio,entidadFederativa, regimen} = datosFiscales;
        const isDataComplete = nombre!=="" && cp!=="" && calle!=="" && numExt!=="" && colonia!=="" && rfc !== "" &&
                            municipio!=="" && entidadFederativa!=="" && Object.entries(datosFiscales.regimen).length !== 0; 
        const hasErrorValidation = this.state.errorRazonSocial || this.state.errorRFC || this.state.errorCodigoPostal || this.state.errorCalle || this.state.errorNoExterior || 
        this.state.errorNoInterior || this.state.errorColonia || this.state.errorMunicipio || this.state.errorEntidadFederativa || this.state.errorLocalidad;
        const disabledAttr = disabled ? "" : "disabled";

        return <Provider store={this.props.redux}>
            <div className="container gnp-emitir-cfdi datos-fis" id="datos-fiscales-form">
                <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>

                <ModalDinamico show={showModal} hasClose={modalDin.hasClose} titulo={modalDin.titulo} imagenHeaderUrl={modalDin.imgHeader} mensaje={modalDin.mensaje} 
                textoBotonDerecho={modalDin.txtBtnDer} textoBotonIzquierdo={modalDin.txtBtnIzq} funcionBotonDerecho={modalDin.fnBtnDer} funcionBotonIzquierdo={modalDin.fnBtnIzq} 
                closeModalFn={(show)=>{
                    this.setState({showModal:show}); 
                    closeFn();} } /> 

                <div className="headerTitleSection"> <div className='bodyTitleSec'> <h1 className='titleTitleSec'>Datos fiscales</h1> <h2 className='subtitleTitleSec'></h2></div>
                </div> <p className="pForm">Ingresa tus datos</p> 
                <div className="pllenado"> Para cumplir con este requisito, adjunta el PDF de tu Constancia de Situación Fiscal actual o ingresa los campos de forma manual.</div>
                <div className='pllenado'>
                    <label className="switch"> <input id="checkbox" type="checkbox" checked={disabled} onChange={this.handleGameClik.bind(this)} />
                    <span className="slider round"></span></label>
                    <p style={{ margin: "-28px 0px 0px 49px" }}>Deseo que GNP facture los seguros que contrato y que la factura se genere con mis datos fiscales capturados.</p>
                </div>
                <div className={`formDatosF-container${!disabled?" disabledContainer":""}`}> <p className="constancia">CONSTANCIA FISCAL</p>
                    <div className="pllenado">
                    Al adjuntar tu Constancia de Situación Fiscal actual, los datos se llenarán de manera automática. Valida que la información sea correcta.
                    </div>
                    <div className="styles" id="archivo">
                        <label className="custom-file-upload agregarArchivo" id="agregarArchivo"    >
                            <div id="attachment"><i className="center-icon"> <img className="imgArchivo" src={require("../img/icon-add.png")} /></i> </div>
                            <input disabled={disabledAttr} onChange={this.handleChange.bind(this)} accept=".pdf" 
                                type="file" id="constanciaInput" style={{ display: "none" }} /> <i /> Agregar archivo </label>
                    </div>
                    <div id="existeArchivo" style={{ display: "none" }}>
                        <img className="imagenFolder" src={require("../img/folder_black_24dp.svg")} /> <p className="cantArchivo">1 archivo</p>
                        <img onClick={this.deleteFile.bind(this)} className="imagenDelete" src={require("../img/delete_black_24dp.svg")} />
                    </div>
                    <hr style={{ background: "#CED8E8", marginTop: "24px", marginBottom: "24px" }}></hr>
                    <p className="datosManual">O ingresa tus datos de forma manual</p> <p className="datosFiscales">DATOS FISCALES</p>
                    <div id='form'><div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap">
                            <label className='input-label'>Nombre o razón social</label>
                            <span className="clearfix">
                                <input id="nombre" className='tooltip-limit' maxLength={254} 
                                style={{  textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold"}} value={nombre} onChange={this.changeInput} 
                                onBlur={this.verify} disabled={disabledAttr} />
                                <span className="orange-tooltip" style={{ float: "right" }}>
                                    <button type='button' className='btn btn-primary btn-lg' data-toggle='modal' data-target='#modal-nombreRazon' 
                                    style={{ marginLeft: "-32px", marginTop: "-19px" }}>?</button>
                                </span>
                                {this.showErrorInput("errorRazonSocial","errorMsjRazonSocial")}
                            </span>
                        </div></div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap">
                                <label>RFC (incluir homoclave)</label>
                                <span className="clearfix">
                                    <input id="rfc" className='tooltip-limit' placeholder="" style={{ textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold"}} 
                                    value={rfc} maxLength={13} onChange={this.changeInput} onBlur={this.verify} disabled={disabledAttr}/>
                                    <span className="orange-tooltip" style={{ float: "right" }}>
                                        <button type='button' className='btn btn-primary btn-lg' data-toggle='modal' data-target='#modal-rfc' 
                                        style={{ marginLeft: "-32px", marginTop: "-19px" }}>?</button>
                                    </span>
                                    {this.showErrorInput("errorRFC","errorMsjRFC")}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>Régimen fiscal</label>
                                <span className="clearfix" >
                                    <Select  onChange={this.changeRegimen.bind(this)} styles={colourStyles} disabled={disabledAttr} 
                                    value={typeof regimen === "object" && regimen.clave ? { label:regimen.descripcion, value: regimen.clave } : { label: "", value: 0 }}  
                                    options={options} style={{color: "#1f3f79", textTransform: "uppercase", fontWeight: "bold"}}>
                                    </Select>
                                    <span className="orange-tooltip" style={{ float: "right" }}>
                                        <button type='button' className='btn btn-primary btn-lg' data-toggle='modal' data-target='#modal-regimen' 
                                        style={{ marginLeft: "-50px", marginTop: "-45px" }}>?</button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <p className="datosFiscales">DIRECCIÓN FISCAL</p>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>Código postal</label>
                                <span className="clearfix">
                                    <input
                                        disabled={disabledAttr} value={cp} onChange={this.changeInput} onBlur={this.verify} className="codigo" 
                                        id="cp" name="codigopostal" maxLength={5} minLength={5} style={{ textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold"}}/>
                                </span>
                                {this.showErrorInput("errorCodigoPostal","errorMsjCodigoPostal")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>Calle</label>
                                <span className="clearfix">
                                    <input
                                        disabled={disabledAttr} value={calle} onChange={this.changeInput} onBlur={this.verify} id="calle" name="calle"
                                        maxLength={60} style={{ textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold" }} />
                                </span>
                                {this.showErrorInput("errorCalle","errorMsjCalle")}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>No. exterior</label>
                            <span className="clearfix">
                            <input disabled={disabledAttr} value={numExt} onChange={this.changeInput} onBlur={this.verify} id="numExt" name="numExt"
                            maxLength={10} style={{ textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold"}} />
                            </span>
                            {this.showErrorInput("errorNoExterior","errorMsjNoExterior")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>No. interior</label>
                                <span className="clearfix">
                                    <input disabled={disabledAttr} value={numInt} onChange={this.changeInput} onBlur={this.verify}
                                        id="numInt" name="numInt" maxLength={10} style={{ textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold" }} />
                                </span>
                                {this.showErrorInput("errorNoInterior","errorMsjNoInterior") }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>Colonia</label>
                                <span className="clearfix">
                                    <input disabled={disabledAttr} value={colonia} onChange={this.changeInput} onBlur={this.verify} id="colonia"
                                        name="colonia" maxLength={50} style={{ textTransform: "uppercase", color: "#1f3f79",  fontWeight: "bold" }}/>
                                </span>
                                {this.showErrorInput("errorColonia","errorMsjColonia") }
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>Municipio</label>
                                <span className="clearfix">
                                    <input disabled={disabledAttr} value={municipio} onChange={this.changeInput} onBlur={this.verify}
                                        id="municipio" name="municipio" maxLength={60} style={{ textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold"}} />
                                </span>
                                {this.showErrorInput("errorMunicipio","errorMsjMunicipio")}
                        </div></div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="input-wrap"> <label>Entidad federativa</label>
                                <span className="clearfix">
                                    <input disabled={disabledAttr} value={entidadFederativa}  onChange={this.changeInput} onBlur={this.verify}
                                    id="entidadFederativa" name="entidadFederativa" maxLength={60} style={{ textTransform: "uppercase", color: "#1f3f79", fontWeight: "bold"}} />
                                </span>
                                {this.showErrorInput("errorEntidadFederativa","errorMsjEntidadFederativa") }
                        </div></div>
                    </div>
                    <button onClick={()=>{this.validarRFC();}} className="buttonStyle btn orange-btn"
                    disabled={!validated || !disabled || hasErrorValidation || !isDataComplete ? "disabled" : ""} 
                    style={{padding: "10px 15px 10px 15px"}}>Confirmar</button>
                </div>
            </div></div>
            <div className='modal fade' id='modal-regimen' tabIndex='-1' role='dialog' aria-labelledby='modal-celularLabel'>
            <div className='modal-dialog' role="document"> <div className='modal-content'>
            <div className='modal-header'> <h4 className='modal-title orange-text' id='modal-celularLabel'>Régimen Fiscal</h4> </div> <div className='modal-body'>
            <p>Información registrada en la cédula fiscal ante el SAT, que definen los derechos y obligaciones que tienes al desempeñar una actividad 
                económica específica.</p><p>Para consultarla puedes ingresar a: <a target="_blank"className="gnp-link" href={regimenURL}>{regimenURL}</a></p>
            </div> <div className="modal-footer"> <button type="button" className="btn btn-primary mr-auto" data-dismiss='modal'>Aceptar</button></div>
            </div></div></div>

            <div className='modal fade' id='modal-rfc' tabIndex='-1' role='dialog' aria-labelledby='modal-celularLabel'><div className='modal-dialog' role="document">
                <div className='modal-content'><div className='modal-header'><h4 className='modal-title orange-text' id='modal-celularLabel'>RFC</h4></div>
                    <div className='modal-body'><p>Para consultar tu RFC puedes ingresar a: <a target="_blank"className="gnp-link" href={rfcURL}>{rfcURL}</a></p></div>
                    <div className="modal-footer"><button type="button" className="btn btn-primary mr-auto" data-dismiss='modal'>Aceptar</button></div>
            </div></div></div>

            <div className='modal fade' id='modal-nombreRazon' tabIndex='-1' role='dialog' aria-labelledby='modal-celularLabel'>
            <div className='modal-dialog' role="document"><div className='modal-content'>
                <div className='modal-header'><h4 className='modal-title orange-text' id='modal-celularLabel'>Nombre o razón social</h4></div><div className='modal-body'>
                    <p>Ingresa tu nombre o razón social tal como se encuentra en tu Constancia de Situación Fiscal. La razón social no contempla el régimen capital.</p>
                    <p>Si requieres consultarla ingresa a: <a target="_blank"className="gnp-link" href={razonURL}>{razonURL}</a></p>
                </div><div className="modal-footer"><button type="button" className="btn btn-primary mr-auto" data-dismiss='modal'>Aceptar</button></div>
            </div></div></div>

            <div className='modal fade' id='modal-err' tabIndex='-1' role='dialog' aria-labelledby='modal-celularLabel'>
            <div className='modal-dialog' role="document"><div className='modal-content'>
                <div className='modal-header'><h4 className='modal-title orange-text' id='modal-celularLabel'>Servicio no disponible</h4></div><div className='modal-body'>
                <p>Intente nuevamente</p></div><div className="modal-footer"><button type="button" className="btn btn-primary mr-auto" data-dismiss='modal'>Aceptar</button>
            </div></div></div></div>
        </Provider>}
        showErrorInput(object_error, object_name){
        const mensaje_error = this.state[object_name];
        const boolean_error = this.state[object_error];
        let html = (<div className="error-wrap"> <div className="msj-error"> <p>{mensaje_error}</p></div></div>);
        if(!boolean_error) { 
            html = "";
        }
        return html;
    }
}



// WEBPACK FOOTER //
// ./src/miPerfil/RegimenFiscal.cmpt.js